import Page from "@jumbo/shared/Page";
import FleeceExpenses from "app/pages/Master/ExpenseMaster/FleeceExpenses";
import AddExpenses from "app/pages/Master/ExpenseMaster/FleeceExpenses/AddExpenses";
import AccessMiddleware from "app/routes/middleware/auth/AccessMiddleware";

export const fleeceExpenseRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "expense_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/expense/fleece",
        element: <Page component={FleeceExpenses} layout={"vertical-default"} />,
      },
      {
        path: "/master/expense/fleece/add/:invoiceId",
        element: <Page component={AddExpenses} layout={"vertical-default"} />,
      }
    ],
  },
];
